<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col quick-nav">
        <div class="links-inner">
          <ul>
            <li v-for="link in quickLinkList" class="nav-item">
              <a
                class="quick-nav-link"
                :class="{ 'active-link': currentUrl === link.url }"
                :href="'https://www.cotopaxi.com' + link.url"
                >{{ link.title }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./ctrl-quick-links"></script>
